import ko from 'knockout';

ko.extenders.withTimeStamp = function(target) {
    target._timestamp = 0;

    target.subscribe(function() {
        target.updateTimeStamp();
    });

    target.getTimeStamp = function() {
        return target._timestamp;
    };

    target.updateTimeStamp = function() {
        target._timestamp = +new Date();
    };
};

ko.observableTS = function() {
    return ko.observable.apply(ko, arguments).extend({withTimeStamp: true});
};
